var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#555",
    fillRule: "evenodd",
    d: "M5 3.571L8.571 0 10 1.429 6.429 5 10 8.571 8.571 10 5 6.429 1.429 10 0 8.571 3.571 5 0 1.429 1.429 0 5 3.571z"
  })));
}
export default SvgX;